import { render, staticRenderFns } from "./addBankGroup.vue?vue&type=template&id=7dd80c08&scoped=true"
import script from "./addBankGroup.vue?vue&type=script&lang=js"
export * from "./addBankGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd80c08",
  null
  
)

export default component.exports